import React from "react";
import { CallToAction } from "components/CallToAction";
import { useAuth } from "hooks";
import { openDownloadModal } from "components/standalone/Download";
import styles from "./UserButton.module.css";

const UserButton = () => {
  const auth = useAuth();
  const actions = [];
  let key, value;
  if (auth.user) {
    key = "loggedin";
    value = "profile";
    actions.push({
      value: "profile",
      label: "Profile",
      icon: "user-circle",
      action: auth.profile,
    });
    actions.push({
      value: "download",
      label: "Download",
      icon: "download",
      action: openDownloadModal,
    });
    actions.push({
      value: "sign-out",
      label: "Sign out",
      icon: "sign-in-alt",
      action: auth.logout,
    });
  } else {
    key = "anonym";
    value = "sign-in";
    actions.push({
      value: "sign-in",
      label: "Sign in",
      icon: "sign-in-alt",
      action: auth.login,
    });
    actions.push({
      value: "sign-up",
      label: "Sign up",
      icon: "user-plus",
      action: auth.register,
    });
    actions.push({
      value: "download",
      label: "Download",
      icon: "download",
      action: openDownloadModal,
    });
  }
  return (
    <CallToAction
      className={styles.button}
      split
      key={key}
      items={actions}
      value={value}
    />
  );
};

export { UserButton };
